import { inject, Injectable } from '@angular/core';
import {
  ACCOUNT_RECOVERY_PAGES,
  CookieHelperService,
  GENERIC,
  LOGIN_MODAL,
  VIEW_PAGE
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import {
  countryandLanguageBlankCode,
  countryandLanguageCode
} from '../../data-access/login-modal/constants/analytics-constants';
import { VIEW_NAME } from '../../data-access/login-modal/constants/login-constant';
import { CountryAndLanguage } from '../../data-access/login-modal/models/adobeAnalytics.interface';
import { LoginModalHelperSuperSupportComponent } from './login-modal-helper-super-support.component';
@Injectable({
  providedIn: 'root'
})
export class LoginModalSuperHelperSupportComponent extends LoginModalHelperSuperSupportComponent {
  cookieHelperService = inject(CookieHelperService);
  checkResetPasswordPage(
    viewName: string,
    pageSection: string,
    viewPage: string
  ): void {
    if (
      pageSection === VIEW_NAME.NEW_RESET_PASSWORD_CHECK_YOUR_EMAIL_SCREEN ||
      pageSection === VIEW_NAME.SECURITY_QUESTION_ANSWER_SCREEN
    ) {
      const action = `${viewPage}:${ACCOUNT_RECOVERY_PAGES.RECOVERY_METHOD}`;
      this.resetPasswordPage(viewName, action);
    }
    if (pageSection === VIEW_NAME.RESET_PASSWORD_SCREEN) {
      const action = `${viewPage}:${ACCOUNT_RECOVERY_PAGES.RESET_PASSWORD}`;
      this.resetPasswordPage(viewName, action);
    }
  }

  checkLoginPage(centerPage: boolean): string {
    const pageType = this.facade.standalonePage
      ? ACCOUNT_RECOVERY_PAGES.STANDALONE
      : centerPage
      ? ACCOUNT_RECOVERY_PAGES.CENTER_PAGE
      : ACCOUNT_RECOVERY_PAGES.GLOBAL_HEADER;
    this.facade.loginPageType$.next(pageType);
    return pageType;
  }

  resetPasswordPage(viewName: string, viewPage: string): void {
    const viewNameMap = {
      [VIEW_PAGE.FORGOT_PASSWORD.toLowerCase()]: VIEW_PAGE.CONTINUE,
      [VIEW_PAGE.SECURITY_QUESTIONS.toLowerCase()]:
        LOGIN_MODAL.SECURITY_QUESTIONS,
      [VIEW_PAGE.CHECK_YOUR_EMAIL.toLowerCase()]: LOGIN_MODAL.CHECK_YOUR_EMAIL
    };

    const name = viewNameMap[viewName.toLowerCase()] || '';
    this.forgotLinkResetPasswordPage(viewName, name, viewPage);
  }

  forgotLinkResetPasswordPage(
    viewName: string,
    name: string,
    viewPage: string
  ): void {
    let action = true;
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_LOGIN) {
      name = LOGIN_MODAL.FORGOT_LOGIN;
      action = false;
    }
    this.adobeDatalayerService.updateAnalyticsLoginModal(
      name,
      viewPage,
      action
    );
  }

  setPrefContent(): CountryAndLanguage {
    const getPrefCookie = this.cookieHelperService.getCookieValue('prefUI');
    let getCountryAndLanguage = countryandLanguageBlankCode;
    if (getPrefCookie && getPrefCookie !== '') {
      const prefCookie = getPrefCookie.split('-');
      getCountryAndLanguage = {
        v39: prefCookie[0],
        v40: prefCookie[1]
      };
    } else {
      getCountryAndLanguage = countryandLanguageCode;
    }
    return getCountryAndLanguage;
  }

  loginScreen(viewName: string, viewPage: string): void {
    let name = '';
    let button = false;
    name = this.checkNameRedirectionLinks(viewName, name);
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.JOIN_SKYMILES) {
      name = LOGIN_MODAL.JOIN_SKYMILES;
      button = true;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.LOG_IN) {
      name = LOGIN_MODAL.LOG_IN;
      button = true;
    }
    this.adobeDatalayerService.updateAnalyticsLoginModal(
      name,
      viewPage,
      button
    );
  }

  checkNameRedirectionLinks(viewName: string, name: string): string {
    name = this.checkNameAlertLinks(viewName, name);
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_LOGIN) {
      name = LOGIN_MODAL.FORGOT_LOGIN;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_PASSWORD) {
      name = LOGIN_MODAL.FORGOT_PASSWORD;
    }
    return name;
  }

  checkNameAlertLinks(viewName: string, name: string): string {
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.NEED_HELP) {
      name = LOGIN_MODAL.LOGIN_HELP;
    }
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.MY_TRIPS) {
      name = LOGIN_MODAL.MY_TRIPS;
    }
    return name;
  }

  resetPasswordButton(viewName: string, pageSection: string): string {
    if (viewName.toLocaleLowerCase() === VIEW_PAGE.FORGOT_PASSWORD) {
      if (pageSection === VIEW_NAME.LOGIN_HELP_SCREEN) {
        return LOGIN_MODAL.RESET_CREATE_PASSWORD;
      }
      return LOGIN_MODAL.RESET_PASSWORD;
    }
    return '';
  }

  setSuccessTracker(action: string): void {
    action == GENERIC.LOGIN_SCREEN
      ? this.successAdobeTracker$.next(true)
      : this.successAdobeTracker$.next(false);
  }
}
